<template>
    <div>
        <masternav/>
        <b-container style="padding:45px;">
    <center v-show="!isAuth">
        <b-form @submit.prevent="login">
      <b-form-group
        id="input-group-1"
        label="Correo Electrónico"
        label-for="input-1"
        description=""
      >
        <b-form-input
          v-model="credenciales.email"
          id="input-1"
          type="email"
          placeholder="example@email.com"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Contraseña" label-for="input-2">
        <b-form-input
          v-model="credenciales.password"
          id="input-2"
          placeholder="********"
          required
          type="password"
        ></b-form-input>
      </b-form-group>

      <b-button block  type="submit" class="btnColor" variant="primary">Iniciar Sesión</b-button>
    </b-form>
    </center>
    
  </b-container>
        <contactcomp/>
        <mainfooter/>
    </div>
</template>

<script>
import masternav from '@/components/masternav.vue'
import Mainfooter from '../components/mainfooter.vue'
import Contactcomp from '../components/contactcomp.vue'
import {mapState, mapGetters} from 'vuex'
import axios from "axios";
    export default {
        components: {
            masternav,
            Mainfooter,
            Contactcomp
        },
        created () {
            if (this.isAuth) {
                this.verificar()
            }
        },
        computed: {
            ...mapGetters('autenticacion', ['isAuth'])
        },
        data() {
            return {
                credenciales:{
                    email:'',
                    password:''
                },
                spinner:false
            }
        },
        methods: {
            verificar() {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
                axios.get(this.$route.params.url).then(resp=>{
                    if (resp.status == 200) {
                        alert(resp.data.message)
                        location.replace('/')
                    }
                })
            },
            login(){
                axios.post('login', this.credenciales).then(resp=>{
                    if (resp.status == 200) {
                        localStorage.setItem('access_token', resp.data)
                        this.verificar()   
                    }
                }).catch(e=>{
                    
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
.btnColor{
    background-color: #006639;
    border-color: #006639;
    border-radius: 0px;
}
</style>